import clsx from "clsx";
import { type ChangeEventHandler, type FC, useRef } from "react";
import { type AriaColorFieldProps, useColorField } from "react-aria";
import { type Color, useColorFieldState } from "react-stately";

import style from "../TextField/TextField.module.css";

export interface HexColorFieldProps extends Omit<AriaColorFieldProps, "onChange"> {
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onValueChange?: (color: Color) => void;
}

export const HexColorField: FC<AriaColorFieldProps> = (props) => {
  /** @see https://github.com/adobe/react-spectrum/issues/5484 */
  const { value: _v, onChange: _oc, ...otherProps } = props;
  const state = useColorFieldState(props);
  const inputRef = useRef(null);
  const { inputProps } = useColorField(otherProps, state, inputRef);

  return (
    <div style={{ width: 74 }} className={clsx(style.input_group)}>
      <input
        data-testid="hex-color-field"
        ref={inputRef}
        {...inputProps}
        onKeyDown={(event) => {
          inputProps.onKeyDown?.(event);
          if (event.key === "Enter") {
            state.commit();
          }
        }}
        aria-label="HEX Color"
        className={clsx(style.input)}
      />
    </div>
  );
};
